import { render, staticRenderFns } from "./Digrab.vue?vue&type=template&id=2022adc4&scoped=true&"
import script from "./Digrab.vue?vue&type=script&lang=js&"
export * from "./Digrab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022adc4",
  null
  
)

export default component.exports